import { getters } from './getters'
import { actions } from './actions'


import { defineStore } from "pinia";

export const useGlobalStore = defineStore("global", {
  getters,
  actions,
});

